/*global ImmersiveReader*/

import { takeLatest } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import callAny from './helpers/call_any'
import formatError from './helpers/error_formatter'
import immersiveReaderSync from 'sync/immersive_reader_sync'
import immersiveReaderActions from 'redux/actions/immersiveReaderActions'
import studentSessionDataSelector from 'redux/selectors/student/student_session_data_selector'
import immersiveReaderSelector from 'redux/selectors/immersive_reader/immersive_reader_selector'
import ivImmersiveReaderSelector from 'redux/selectors/interactive_videos/interactive_video_immersive_reader_selector'

function *immersiveReaderTransform(chunks) {
	const sessionData = yield select(studentSessionDataSelector)
	const {
		payload: {
			token,
			subdomain,
		},
	} = yield callAny(
		immersiveReaderSync.getCredentials,
		sessionData.headers.jwt
	)

	const content = {
		title: 'Nearpod Slide',
		chunks: chunks.map(chunk => ({ content: chunk + '\n' })),
	}

	ImmersiveReader.launchAsync(token, subdomain, content)
	yield put(immersiveReaderActions.immersiveReaderTransformSuccess())
}

function *immersiveReaderTransformSlide(action) {
	try {
		const chunks = yield select(immersiveReaderSelector, action.slideId)
		yield call(immersiveReaderTransform, chunks)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			immersiveReaderActions.immersiveReaderTransformError(serverError)
		)
	}
}

function *immersiveReaderTransformIVActivity(action) {
	try {
		const chunks = yield select(ivImmersiveReaderSelector, action.activityUid)
		yield call(immersiveReaderTransform, chunks)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			immersiveReaderActions.immersiveReaderTransformError(serverError)
		)
	}
}

function *immersiveReaderTransformText(action) {
	try {
		const chunks = [action.text]
		yield call(immersiveReaderTransform, chunks)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			immersiveReaderActions.immersiveReaderTransformError(serverError)
		)
	}
}

function *immersiveReaderTransformFromTexts(action) {
	try {
		const chunks = action.texts
		yield call(immersiveReaderTransform, chunks)
	} catch (error) {
		const serverError = formatError(error)
		yield put(immersiveReaderActions.immersiveReaderTransformError(serverError))
	}
}

export default [
	takeLatest([
		actionTypes.IMMERSIVE_READER_OEQ_TRANSFORM,
		actionTypes.IMMERSIVE_READER_POLL_TRANSFORM,
		actionTypes.IMMERSIVE_READER_QUIZ_TRANSFORM,
		actionTypes.IMMERSIVE_READER_DRAW_IT_TRANSFORM,
	], immersiveReaderTransformSlide),
	takeLatest([
		actionTypes.IMMERSIVE_READER_MATCHING_PAIRS_TRANSFORM,
	], immersiveReaderTransformText),
	takeLatest([
		actionTypes.IMMERSIVE_READER_READ_ONLY_TRANSFORM,
	], immersiveReaderTransformFromTexts),
	takeLatest([
		actionTypes.INTERACTIVE_VIDEO_IMMERSIVE_READER_OEQ_TRANSFORM,
		actionTypes.INTERACTIVE_VIDEO_IMMERSIVE_READER_MCQ_TRANSFORM,
	], immersiveReaderTransformIVActivity),
]

export {
	immersiveReaderTransform,
	immersiveReaderTransformFromTexts,
}
